<!-- 异常（遥控）开闸数据上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "",
          "cmd": "reportAbnormalCarIn",
          "parkingCode": "",
          "enterCarCodeColor": "",
          "enterCarCode": "",
          "enterCarCodeType": 0,
          "carCode": 5,
          "enterChannelCode": 0,
          "enterNovipCode": "",
          "isCorrect":"",
          "enterChannelName": 0,
          "inOperatorName": 0,
          "enterChannelId": "",
          "enterVipType": 0,
          "enterType": 1,
          "enterImageArray": 0,
          "inOperatorTime": 500,
          "recordType": 0,
          "lockKey": 0
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报停车场异常进场信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportAbnormalCarIn",
          precondition: "无",
          fitSystem: "云车场,VEMS传统停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'

            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                info1: 'parkingCode',
                info2: '是',
                info3: 'String',
                info4: '停车记录'
              },
              {
                info1: 'enterCarCodeColor',
                info2: '否',
                info3: 'Integer',
                info4: '进场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）'
              },
              {
                info1: 'enterCarCode',
                info2: '是',
                info3: 'String',
                info4: '进场车牌'
              },
              {
                info1: 'enterCarCodeType',
                info2: '否',
                info3: 'Integer',
                info4: '进场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3黑牌白字，4白牌）'
              },
              {
                info1: 'carCode',
                info2: '是',
                info3: 'String',
                info4: '最终车牌'
              },
              {
                info1: 'enterRecognitionConfidence',
                info2: '否',
                info3: 'Decimal',
                info4: '进场识别置信度'

              },
              {
                info1: 'cardCode',
                info2: '否',
                info3: 'String',
                info4: '卡编号'
              },
              {
                info1: 'enterTime',
                info2: '是',
                info3: 'String',
                info4: '进场放行时间，yyyyMMddHHmmss'
              },
              {
                info1: 'confidence',
                info2: '是',
                info3: 'Decimal',
                info4: '最终识别置信度'
              },
              {
                info1: 'enterCarType',
                info2: '否',
                info3: 'Integer',
                info4: '车辆类型（0未知，1蓝牌车，2黄牌车"，3超大型车 4新能源小车，5新能源大车（vems：20 非机动车））'
              },
              {
                info1: 'enterChannelCode',
                info2: '是',
                info3: 'String',
                info4: '入口通道编号'
              },
              {
                info1: 'enterNovipCode',
                info2: '否',
                info3: 'Integer',
                info4: '进场说明（<url>参考附录:/Api/appendixData#appendixData_2</url>）'
              },
              {
                info1: 'isCorrect',
                info2: '是',
                info3: 'Integer',
                info4: '车牌是否被纠正（0未纠正，1已纠正）'
              },
              {
                info1: 'enterChannelName',
                info2: '否',
                info3: 'String',
                info4: '进场通道名'
              },
              {
                info1: 'inOperatorName',
                info2: '是',
                info3: 'String',
                info4: '操作人'
              },
              {
                info1: 'enterChannelId',
                info2: '否',
                info3: 'Long',
                info4: '进场通道ID'
              },

              {
                info1: 'enterVipType',
                info2: '是',
                info3: 'Integer',
                info4: '进场Vip类型（<url>参考附录:/Api/appendixData#appendixData_4</url>）'
              },

              {
                info1: 'enterType',
                info2: '是',
                info3: 'Integer',
                info4: '进场类型（<url>参考附录:/Api/appendixData#appendixData_5</url>）'
              },
              {
                info1: 'enterImageArray',
                info2: '是',
                info3: 'JSONArray',
                info4: '进场图片列表，[{"plateImage":"车牌图片直接访问url","carImage":"车身图片直接访问url"}]'
              },



              {
                info1: 'inOperatorTime',
                info2: '是',
                info3: 'String',
                info4: '进场放行时间，yyyyMMddHHmmss'
              },
              {
                info1: 'recordType',
                info2: '否',
                info3: 'Integer',
                info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）'
              },

              {
                info1: 'lockKey',
                info2: '是',
                info3: 'String',
                info4: '数据唯一标识'
              },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportAbnormalCarIn.vue